/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  var cart = {
    container: '.cart-dropdown'
  };

  var giftWrap = {
    overlay: '.gift-wrap-overlay',
    container: '.gift-wrap-container',
    yesButton: '.gift-wrap-yes',
    noButton: '.gift-wrap-no',
    saveAndClose: '.gift-save-close',
    giftReceipt: '#gift-receipt',
    closeModal: '.close-gift-modal',
    giftSelected: '.gift-box-selected',
    giftWidget: '#gift-wrap-widget',
    giftWrapOptions: '#gift-options',
    giftOptionPrice: '#gift-option-price',
    giftWrapForm: '.gift-wrap-container form',
    giftWrapId: '.gift-wrap-container #gift-id',
    giftWrapImage: '.gift-wrap-container .gift-wrap-image',

    openGiftWrapModal: (e) => {
      e.preventDefault();
      $(giftWrap.yesButton).addClass('active');
      $(giftWrap.noButton).removeClass('active');
      $(giftWrap.overlay).css('display', 'flex');
      $('body').css('overflow', 'hidden');
      $(cart.container).removeClass('is-open');

      if ($(giftWrap.giftReceipt).length == 0) {
        $(giftWrap.giftWidget).closest('form').append('<input type="hidden" id="gift-receipt" name="attributes[gift-receipt]" value="true">');
      }
    },

    toggleOverlay: (e) => {
      if (!$(giftWrap.container)[0].contains(e.target)) {
        $(giftWrap.overlay).hide();
        $('body').css('overflow', '');
      }
    },

    hideOverlay: (e) => {
      e.preventDefault();
      $(giftWrap.overlay).hide();
      $('body').css('overflow', '');
      $('html').removeAttr('data-scroll-locked');
      $('html').removeClass('has-open-cart-dropdown');
    },

    closeGiftModal: (e) => {
      e.preventDefault();
      $(giftWrap.noButton).addClass('active');
      $(giftWrap.yesButton).removeClass('active');
      $(giftWrap.giftCheckbox).prop( "checked", false );

      $(giftWrap.overlay).hide();
      $('body').css('overflow', '');

      $(giftWrap.giftReceipt).remove();
    },

    changeGiftOption: (e) => {
      e.preventDefault();
      var option = $(giftWrap.giftWrapOptions + ' option:selected');

      $(giftWrap.giftOptionPrice).text(option.data('price'));
      $(giftWrap.giftWrapForm).attr('id', 'product_form_' + option.val());
      $(giftWrap.giftWrapId).val(option.val());
      $(giftWrap.giftCheckbox).data('product-id', option.val());
      $(giftWrap.giftWrapImage).attr('src', option.data('src'));
    }
  };

  $(document).on('click', giftWrap.yesButton ,function(e) {
    giftWrap.openGiftWrapModal(e);
  });

  $(document).on('click', giftWrap.overlay, function(e) {
    giftWrap.toggleOverlay(e);
  });

  $(document).on('click', giftWrap.noButton, function(e) {
    giftWrap.closeGiftModal(e);
  });

  $(document).on('click', giftWrap.saveAndClose, function(e) {
    giftWrap.hideOverlay(e);
  });

  $(document).on('click', giftWrap.closeModal, function(e) {
    giftWrap.hideOverlay(e);
  });

  $(document).on('change', giftWrap.giftWrapOptions, function(e) {
    giftWrap.changeGiftOption(e);
  });

  $('.faq-questions .faq-question').click(function (e) {
    $(this).find('.faq-answer').toggle();
    
    if ($(this).find('.faq-toggle').hasClass('plus')) {
      $(this).find('.faq-toggle').removeClass('plus');
      $(this).find('.faq-toggle').addClass('minus');
      $(this).find('.faq-toggle > svg').remove();
      $(this).find('.faq-toggle').append('<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 20 20"><path fill="#444" d="M17.543 11.029H2.1A1.032 1.032 0 011.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"/></svg>');
    } else {
      $(this).find('.faq-toggle').removeClass('minus');
      $(this).find('.faq-toggle').addClass('plus');
      $(this).find('.faq-toggle > svg').remove();
      $(this).find('.faq-toggle').append('<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 20 20"><path fill="#444" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"/></svg>');
    }
  });

  $('.faq-container .faq-category-title').click(function (e) {
    $('.faq-container .faq-category-title.active').removeClass('active');
    $(this).addClass('active');

    var title = $(this).data('title');

    $('.faq-container .faq-questions.active').removeClass('active');

    $('.faq-container .faq-questions').each(function(e) {
      if ($(this).data('title') == title) {
        $(this).addClass('active');
      }
    });
  });

  $('#rewards-history-container .close-modal').on('click', function(e) {
    $('body').removeClass('no-scroll');
    $('#rewards-history-container').hide();
  });

  $('#rewards-history-container').on('click', function(e) {
    if ($('.rewards-history__inner')[0].contains(e.target) == false) {
      $('body').removeClass('no-scroll');
      $('#rewards-history-container').hide();
    }
  });

  $('.js-slider').each(function(e) {
    if ($(this).hasClass('desktop-only')) {
      if ($(window).width() > 768) {
        setupSlick($(this));
      }
    } else if ($(this).hasClass('mobile-only')) {
      if ($(window).width() < 769) {
        setupSlick($(this));
      }
    } else {
      setupSlick($(this));
    }
  })

  setCustomContentHeight();
})();

function setCustomContentHeight() {
  $('.brick__section').each(function(e) {
    if($(this).data('content-banner') != undefined) {
      var height = $(this).find('.brick__block__image .image__hero__frame').height();
      $(this).find('.brick__block__image .image__hero__frame').height(height - 240);
    }
  })
}

function setupSlick(slider) {
  // slider.slick({
  //   dots: false,
  //   arrows: false,
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  // });
}

// iOS Safari back navigation fix: releases bodyScrollLock listeners and clears Boost PFS states
function clearStuckScrollLocks() {
  if (window.themeVendor && window.themeVendor.BodyScrollLock) {
    window.themeVendor.BodyScrollLock.clearAllBodyScrollLocks();
  }
  document.documentElement.removeAttribute('data-scroll-locked');
  document.documentElement.classList.remove('boost-pfs-body-no-scroll', 'boost-pfs-body-no-scroll-normal');
  document.body.classList.remove('boost-pfs-filter-custom-drawer-open');
  document.body.style.overflow = '';
  document.querySelectorAll('.boost-pfs-filter-loading').forEach(function(el) {
    el.style.display = 'none';
  });
}

window.addEventListener('pageshow', function(e) {
  var navEntry = performance.getEntriesByType('navigation')[0];
  if (e.persisted || (navEntry && navEntry.type === 'back_forward')) {
    clearStuckScrollLocks();
    setTimeout(clearStuckScrollLocks, 800);
  }
});

// wishlist link
document.addEventListener("DOMContentLoaded", function() {
  const wishlistLinks = document.querySelectorAll('status-saved-link');
  const saveToWishlist = document.querySelectorAll('status-save-button');

  wishlistLinks.forEach(wishlistLink => {
    if (wishlistLink && wishlistLink.shadowRoot) {
      const style = document.createElement('style');
      style.textContent = `
        :host, * {
          width: auto;
          height: auto;
          text-align: left;
          padding: 0;
          margin: 0;
        }
        .indicator {
          display: none;
        }
        status-icon {
          color: #000;
          width: auto;
          align-self: flex-start;
          text-align: left;
        }
        .saved-link {
          justify-content: flex-start;
          align-items: center;
          width: auto;
          height: auto;
        }
        status-icon {
          color: var(---color-footer-link);
        }
        status-icon:hover {
          color: var(---color-footer-link-hover);
        }
        .save-button .icon-wrapper {
          display: block;
          width: fit-content;
          font-size: 12px;
          text-transform: capitalize;
          padding: 0;
          margin: 0;
          margin-top: 12px;
          line-height: normal;
          border-radius: 0;
          box-shadow: none;
          border: none;
        }
      `;
      wishlistLink.shadowRoot.appendChild(style);
    }
  });  
  saveToWishlist.forEach(wishlistLink => {
    if (wishlistLink && wishlistLink.shadowRoot) {
      const style = document.createElement('style');
      style.textContent = `
        .save-button .icon-wrapper {
          display: block;
          width: fit-content;
          font-size: 12px;
          text-transform: capitalize;
          padding: 0;
          margin: 0;
          margin-top: 12px;
          line-height: normal;
          border-radius: 0;
          box-shadow: none;
          border: none;
        }
      `;
      wishlistLink.shadowRoot.appendChild(style);
    }
  }); 

  const pdpSaveLink = document.querySelector('.pdp-save-link');

  if (pdpSaveLink) {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.addedNodes.length > 0) {
          const statusSaveButton = mutation.target.querySelector('status-save-button');
          if (statusSaveButton) {
            const shopifyBlock = statusSaveButton.closest('.shopify-block');
            if (shopifyBlock) {
              console.log("status-save-button found");
              pdpSaveLink.parentElement.removeChild(pdpSaveLink);
              shopifyBlock.appendChild(pdpSaveLink);
              observer.disconnect(); // Stop observing
            }
          }
        }
      });
    });
  
    const rootNode = document.body; // Observe the entire DOM; can be narrowed down
    observer.observe(rootNode, { childList: true, subtree: true });
  }

  // rewards page
  if (window.location.href.includes('/pages/rewards')) {
    setTimeout(() => {
      const rewardItems = document.querySelectorAll('.lion-reward-item');
      rewardItems.forEach((item) => {
        const titleElem = item.querySelector('.lion-reward-item__title');
        const percentOffElem = item.querySelector('.lion-reward-item__percent-off');
        let titleText = titleElem ? titleElem.textContent : '';
        let percentOffText = percentOffElem ? percentOffElem.textContent : '';
  
        if (percentOffText.includes('Free product')) {
          titleText = titleText.replace('100% off', 'Free');
          percentOffElem.style.display = 'none';
        }
  
        if (titleText.includes('$25') || titleText.includes('$50') || titleText.includes('$75') || titleText.includes('$100')) {
          titleText = titleText.replace('voucher', 'Off');
        }

        if (titleText.toLowerCase().includes('free shipping')) {
          titleText = titleText.replace('voucher', '');
        }
  
        titleText = titleText.replace(/\b\w/g, (l) => l.toUpperCase());
  
        if (titleElem) {
          titleElem.textContent = titleText;
        }
      });
    }, 1000);
  }
  
  
});

